import firebase from "firebase/app";
import {
  convertToHeartRateAlertSetting,
  HeartRateAlertSetting,
  heartRateAlertSettingCollectionKey,
  HeartRateAlertSettingData
} from "@/entities/heart_rate_alert_setting";
import { School } from "@/entities/school";

export async function createHeartRateAlertSetting(
  data: HeartRateAlertSettingData,
  school: School
): Promise<HeartRateAlertSetting> {
  const ref = await school.ref
    .collection(heartRateAlertSettingCollectionKey)
    .add(data);
  return { data, ref };
}

export async function getHeartRateAlertSetting(
  ref: firebase.firestore.DocumentReference
): Promise<HeartRateAlertSetting | null> {
  const snapshot = await ref.get();
  if (!snapshot.exists) return null;
  if (!snapshot.data()) return null;
  return convertToHeartRateAlertSetting(snapshot.data()!, snapshot.ref);
}

export async function getHeartRateAlertSettings(
  school: School
): Promise<HeartRateAlertSetting[]> {
  const snapshot = await school.ref
    .collection(heartRateAlertSettingCollectionKey)
    .get();

  if (snapshot.empty) return [];

  return snapshot.docs
    .filter(doc => doc.exists && doc.data())
    .map(doc => convertToHeartRateAlertSetting(doc.data(), doc.ref));
}

export async function updateHeartRateAlertSetting(
  data: Partial<HeartRateAlertSettingData>,
  ref: firebase.firestore.DocumentReference
): Promise<{
  updatedData: Partial<HeartRateAlertSettingData>;
  ref: firebase.firestore.DocumentReference<firebase.firestore.DocumentData>;
}> {
  await ref.update(data);
  return { updatedData: data, ref };
}

export async function deleteHeartRateAlertSetting(
  ref: firebase.firestore.DocumentReference
) {
  await ref.delete();
}

export async function getHeartRateAlertSettingOfStudent(
  school: School,
  studentRef: firebase.firestore.DocumentReference
): Promise<HeartRateAlertSetting | null> {
  const snapshot = await school.ref
    .collection(heartRateAlertSettingCollectionKey)
    .where("targetStudentRefs", "array-contains", studentRef)
    .get();

  if (snapshot.empty) return null;

  if (!snapshot.docs[0].exists || !snapshot.docs[0].data()) return null;

  return convertToHeartRateAlertSetting(
    snapshot.docs[0].data(),
    snapshot.docs[0].ref
  );
}
